import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div`
  z-index: 1000;
  top: 0;
  right: 0;
  position: fixed;
  height: 100vh;
  width: 100vw;
`;

export const Overlay = styled.div`
  height: 100vh;
  width: 100vw;
  top: 0;
  right: 0;
  z-index: 0;
  background: rgba(0, 0, 0, 0.8);
  cursor: pointer;
`;

export const MainImage = styled.img`
  height: auto;
  max-height: 80vh;
  width: 80vw;
  top: 50%;
  left: 50%;
  object-fit: contain;
  transform: translate(-50%, -50%);
  z-index: 1;
  position: absolute;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
`;

export const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 50px;
  position: absolute;
  z-index: 2;
  width: 90%;
  overflow-x: auto;
`;

export const Thumbnail = styled.img<{ active: boolean }>`
  object-fit: cover;
  width: 9vh;
  height: 5vh;
  margin-right: 10px;
  opacity: ${(props) => (props.active ? 1 : 0.4)};
  transition: opacity 0.3s ease-in-out;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  &:hover {
    opacity: ${(props) => (props.active ? 1 : 0.7)};
  }
`;

export const iconStyle = css`
  width: 40px;
  height: 40px;
  color: white;
  z-index: 2;
  position: absolute;
  cursor: pointer;
`;

export const iconLeftStyle = css`
  ${iconStyle}
  top: 50%;
  transform: translate(0, -50%);
  left: 20px;
`;

export const iconRightStyle = css`
  ${iconStyle}
  top: 50%;
  transform: translate(0, -50%);
  right: 20px;
`;

export const iconCloseStyle = css`
  ${iconStyle}
  width: 30px;
  height: 30px;
  top: 20px;
  right: 20px;
`;
